import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {HeaderFilter} from 'asax-common';
import {TextSearchInput} from "../search-input.model";

@Component({
  selector: 'asax-header-search-input-switch',
  templateUrl: './search-input-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputSwitchComponent implements OnInit, OnChanges {
  @Input() searchInput: TextSearchInput;

  @Output() outFilter = new EventEmitter<HeaderFilter>();

  valueSubject = new Subject<string>();

  readonly scienceKeywordUncheckedTooltipTitle = 'Not only public data';
  readonly scienceKeywordCheckedTooltipTitle = 'Public data only';
  
  readonly scienceKeywordUncheckedTextInfo = 'All observations that have been observed are displayed.' 
  readonly scienceKeywordUncheckedTextDescription = 'Toggle to display only the observations that are out of their proprietary period and are public.';
  
  readonly scienceKeywordCheckedTextInfo = 'Displayed, are only the observations that are out of their proprietary period and are public.'
  readonly scienceKeywordCheckedTextDescription = 'Toggle to display all observations that have been observed.';

  readonly calibrationObservationsUncheckedTooltipTitle = 'Only science observations';
  readonly calibrationObservationsCheckedTooltipTitle = 'Science observations and calibration observations';
  
  readonly calibrationObservationsUncheckedTextInfo = 'Only the science observations are displayed.' 
  readonly calibrationObservationsUncheckedTextDescription = 'Toggle to display science and calibration observations.';
  
  readonly calibrationObservationsCheckedTextInfo = 'The science and calibration observations are displayed.'
  readonly calibrationObservationsCheckedTextDescription = 'Toggle to display only the science observations.';

  tooltipTitle: string;
  tooltipTextInfo: string;
  tooltipTextDescription: string;

  ngOnInit(): void {
    this.valueSubject.asObservable().pipe(
      tap(() => this.emitFilter())
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.valueChanged();
    if (this.searchInput) {
      this.initTooltipTitleAndText(this.searchInput.value);
    }
  }

  valueChanged(): void {
    this.valueSubject.next(undefined);
  }

  initTooltipTitleAndText(checked: string) {
    if (this.searchInput.label == 'Public data only') {
      this.tooltipTitle = checked == 'true' 
              ? this.scienceKeywordCheckedTooltipTitle 
              : this.scienceKeywordUncheckedTooltipTitle;
      this.tooltipTextInfo = checked == 'true' 
              ? this.scienceKeywordCheckedTextInfo 
              : this.scienceKeywordUncheckedTextInfo;
      this.tooltipTextDescription = checked == 'true' 
              ? this.scienceKeywordCheckedTextDescription 
              : this.scienceKeywordUncheckedTextDescription;
    }
    if (this.searchInput.label == 'Calibration observations') {
      this.tooltipTitle = checked == 'true' 
              ? this.calibrationObservationsCheckedTooltipTitle 
              : this.calibrationObservationsUncheckedTooltipTitle;
      this.tooltipTextInfo = checked == 'true' 
              ? this.calibrationObservationsCheckedTextInfo 
              : this.calibrationObservationsUncheckedTextInfo;
      this.tooltipTextDescription = checked == 'true' 
              ? this.calibrationObservationsCheckedTextDescription 
              : this.calibrationObservationsUncheckedTextDescription;
    }
  }

  toggleValue(checked: string): void {
    this.searchInput.value = checked;
    this.initTooltipTitleAndText(checked);
    this.valueChanged();
  }

  clearSearchInputValue(): void {
    this.searchInput.value = undefined
    this.valueChanged();
  }

  emitFilter(): void {
    const filter = {
      id: this.searchInput.id,
      value: this.searchInput.value === 'true' ? 'true' : '',
      valueParsed: this.searchInput.value === 'true' ? true : false,
      valueToDisplay: this.searchInput.value === 'true' ? 'true' : '',
      label: this.searchInput.label,
      isDisabled: this.searchInput.isDisabled,
      elasticParserType: this.searchInput.elasticParserType
    };

    this.outFilter.emit(filter);
  }
}
